import { jsx as o } from "react/jsx-runtime";
const h = ({ size: C, className: r }) => /* @__PURE__ */ o(
  "svg",
  {
    className: r,
    fill: "none",
    height: C,
    viewBox: "0 0 7 13",
    width: C,
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ o(
      "path",
      {
        d: "M4.88926 6.50056L0.256011 11.4165C0.174666 11.5025 0.110118 11.6047 0.0660739 11.7173C0.02203 11.8298 -0.000643253 11.9505 -0.000643253 12.0724C-0.000643253 12.1943 0.02203 12.315 0.0660739 12.4276C0.110118 12.5401 0.174666 12.6423 0.256011 12.7284C0.42118 12.9019 0.644186 12.9993 0.876578 12.9993C1.10897 12.9993 1.33198 12.9019 1.49715 12.7284L6.7481 7.15851C6.90686 6.98948 6.99813 6.76196 7.00293 6.52328C7.00773 6.2846 6.92569 6.05315 6.77388 5.87707L1.50001 0.270736C1.41889 0.184198 1.32252 0.115474 1.21639 0.0684875C1.11026 0.0215009 0.996452 -0.00282788 0.881468 -0.00311031C0.766484 -0.00339273 0.652573 0.0203767 0.54624 0.0668414C0.439907 0.113306 0.343232 0.181556 0.261738 0.267694C0.180244 0.353832 0.115526 0.456172 0.0712781 0.568869C0.0270299 0.681567 0.00411881 0.802416 0.00385284 0.924516C0.00358688 1.04662 0.0259721 1.16758 0.0697289 1.28049C0.113486 1.3934 0.177758 1.49606 0.258876 1.5826L4.88926 6.50056Z",
        fill: "currentColor"
      }
    )
  }
);
export {
  h as IosArrowRight
};
